<template>
  <Header title="Invoice Pembayaran" link1="Tagihan" :link2="student.name"></Header>
  <div class="row pt-2">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body p-3">
          <h4 class="text-secondary d-inline">
            <button @click="$router.go(-1)" class="btn btn-light rounded-pill"> <ion-icon name="arrow-back-outline"></ion-icon> </button>
            Kembali
          </h4>
          <button v-if="additional_data.is_hide_download_invoice == false || (additional_data.is_hide_download_invoice == true && (order.status == constants.ORDER_SUCCESS || order.status == constants.ORDER_SUCCESS_MANUAL || !order.us_order))" @click="customInvoice ? getCustomInvoice() : print()" class="btn btn-link-gray float-end"> Unduh Invoice <ion-icon name="download-outline"></ion-icon> </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-md-12">
      <div class="card" id="print">
        <div class="card-body">
          <div class="card card-invoice border-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-end">
                  <h3 class="mb-4">INVOICE #{{order.invoice_no}}</h3>
                </div>
              </div>
              <div class="row p-3">
                <div class="col-md-6">
                  <!-- <img class="header-logo" src="/img/santoyakobus.png" alt=""> -->
                  <div v-if="order.status == constants.ORDER_SUCCESS || order.status == constants.ORDER_SUCCESS_MANUAL">
                    <h5 class="text-secondary mt-3">Tanggal Pembayaran</h5>
                    <h4>{{ beautifyDatetime(order.payment_date) }}</h4>
                  </div>
                  <div v-else>
                    <h5 class="text-secondary mt-3">Batas Pembayaran</h5>
                    <h4>{{ beautifyDatetime(order.expired_date) }}</h4>
                  </div>
                </div>
                <div class="col-md-6 text-end">
                  <h5 class="fs3 fw-bold">{{ student.name }}</h5>
                  <h5 class="fs4">{{ student.student_profile.nis }}</h5>
                  <h5 class="fs4">{{ student?.class?.name }}</h5>
                  <h5 class="fs4">{{ school.name }}</h5>
                </div>
              </div>
              <div class="row p-3">
                <table class="table table-borderless table-invoice">
                  <thead>
                    <tr class="bg-primary">
                      <th>Nama Tagihan</th>
                      <th>Periode</th>
                      <!-- <th>Batas Akhir</th> -->
                      <th class="text-end">Total Bayar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detail in billUserInstallments" :key="detail.id">
                      <td>{{ detail.bill_user.bill.name }}</td>
                      <td>
                        <span class="badge bg-primary mr-1">{{ getMonth(detail.bill_user.id) }}</span>
                        <span class="badge bg-primary mr-1">{{ detail.bill_user.bill.school_year.name }}</span>
                      </td>
                      <!-- <td>{{ beautifyDatetime(detail.deadline_date) }}</td> -->
                      <td class="text-primary text-end fw-bold"> Rp{{ toLocaleString(detail.amount) }} </td>
                    </tr>
                    <tr v-if="order.total_charge > 0">
                      <td>Denda</td>
                      <td></td>
                      <td class="text-primary text-end fw-bold"> Rp{{ toLocaleString(order.total_charge) }} </td>
                    </tr>
                    <tr v-if="order.convenience_fee > 0">
                      <td>Biaya Admin</td>
                      <td></td>
                      <td class="text-primary text-end fw-bold"> Rp{{ toLocaleString(order.convenience_fee) }} </td>
                    </tr>
                    <tr v-if="order.merchant_fee > 0">
                      <td>Biaya Merchant</td>
                      <td></td>
                      <td class="text-primary text-end fw-bold"> Rp{{ toLocaleString(order.merchant_fee) }} </td>
                    </tr>
                    <tr v-if="order.total_discount > 0">
                      <td>Potongan Harga</td>
                      <td></td>
                      <td class="text-danger text-end fw-bold"> Rp -{{ toLocaleString(order.total_discount) }} </td>
                    </tr>
                    <tr v-if="order.ppn > 0">
                      <td>PPN</td>
                      <td></td>
                      <td class="text-primary text-end fw-bold"> Rp {{ toLocaleString(order.ppn) }} </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end pt-4 pb-4"> <span class="text-secondary fs-3">Jumlah Total</span> </td>
                      <td class="text-end pt-4 pb-4"> <span class="text-primary fw-bold fs-3">Rp{{ toLocaleString(order.total_payment) }}</span> </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-end pt-4 pb-4"></td>
                      <td class="text-end pt-4 pb-4">
                        <span v-if="order.us_order">
                          <a class="btn btn-primary" @click="handlePayment(order.us_order_id)" v-if="order.status == constants.ORDER_BEGIN || order.status == constants.ORDER_PENDING"><ion-icon name="card-outline"></ion-icon> Bayar</a>
                          <a class="btn btn-success no-pointer" v-if="order.status == constants.ORDER_SUCCESS || order.status == constants.ORDER_SUCCESS_MANUAL"><ion-icon name="checkmark-outline"></ion-icon> Lunas</a>
                          <p class="text-danger" v-if="order.status == constants.ORDER_CANCELED || order.status == constants.ORDER_EXPIRED">Pembayaran Kedaluwarsa</p>
                          <a class="btn btn-primary" @click="handleExpiredPayment(order.us_order_id)" v-if="order.status == constants.ORDER_CANCELED || order.status == constants.ORDER_EXPIRED"><ion-icon name="card-outline"></ion-icon> Bayar Ulang</a>
                          <button v-if="order.us_order.status == 600" @click="loadData()" class="btn btn-icon btn-link-gray"><ion-icon name="refresh-circle-outline"></ion-icon> Refresh</button>
                        </span>
                        <span v-else>
                          <a class="btn btn-success no-pointer" v-if="order.status == constants.ORDER_SUCCESS || order.status == constants.ORDER_SUCCESS_MANUAL"><ion-icon name="checkmark-outline"></ion-icon> Lunas</a>
                          <a class="btn btn-primary" @click="handlePayment2(order)" v-if="order.status == constants.ORDER_BEGIN || order.status == constants.ORDER_PENDING"><ion-icon name="card-outline"></ion-icon> Bayar</a>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-secondary">
                      <td colspan="4" class="p-4">
                        <img src="https://aimsis.com/v2/img/ic_logo.svg" alt="">
                        <button class="btn btn-link-gray float-end no-pointer"> 0816-237-121 <ion-icon name="logo-whatsapp"></ion-icon> </button>
                        <button class="btn btn-link-gray float-end no-pointer"> 021-533-2222 <ion-icon name="call-outline"></ion-icon> </button>
                        <button class="btn btn-link-gray float-end no-pointer"> info@aimsis.com <ion-icon name="mail-outline"></ion-icon> </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="xenditModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pembayaran</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <iframe v-if="xenditInvoice != ''" :src="xenditInvoice" frameborder="0" width="100%" height="700"></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" @click="loadData()"> <ion-icon name="close-outline"></ion-icon> Tutup</button>
        </div>
      </div>
    </div>
  </div>

  <div id="bcaModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pembayaran</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Nomor Invoice</td>
                        <td>: {{ bca.invoice_number }}</td>
                      </tr>
                      <tr>
                        <td>Nomor VA</td>
                        <td>: <b>{{ bca.va_number }}</b></td>
                      </tr>
                      <tr v-if="bca.va_number_nobill">
                        <td>Nomor Perkiraan</td>
                        <td>: <b>{{ bca.va_number_nobill }}</b></td>
                      </tr>
                      <tr>
                        <td>Bank</td>
                        <td>: {{ bca.bank_name }}</td>
                      </tr>
                      <tr>
                        <td>Tarif Admin</td>
                        <td>: Rp{{ toLocaleString(bca.convenience_fee) }}</td>
                      </tr>
                      <tr>
                        <td>Tarif Merchant</td>
                        <td>: Rp{{ toLocaleString(bca.merchant_fee) }}</td>
                      </tr>
                      <tr v-if="bca.total_discount">
                        <td>Potongan</td>
                        <td>: Rp{{ toLocaleString(bca.total_discount) }}</td>
                      </tr>
                      <tr v-if="bca.ppn">
                        <td>PPN</td>
                        <td>: Rp{{ toLocaleString(bca.ppn) }}</td>
                      </tr>
                      <tr>
                        <td><h5 class="fw-bold">Jumlah Pembayaran</h5></td>
                        <td>: <h5 class="fw-bold text-primary">Rp{{ toLocaleString(bca.total_payment) }}</h5></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"> <ion-icon name="close-outline"></ion-icon> Tutup</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-invoice {
  font-size: 13px;
}

.header-logo {
  width: 200px;
}

.card-invoice {
  border-radius: 0;
}

.no-pointer {
  cursor: default;
}
</style>

<script language="ts" src="./scripts/bill-invoice.ts"></script>
